import React from 'react'

import isDOMAvailable from 'utils/isDOMAvailable'

import {
  Container,
  Row,
  Col,
} from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import TmvnCarousel from 'components/molecules/TmvnCarousel'
import MajorItem from './MajorItem'

const majorsData = [
  {
    id: '1',
    title: 'Software Engineering',
    desc: 'Quipperian akan mendapatkan silabus dan kurikulum pembelajaran yang senantiasa diperbarui setiap semester mengikuti perkembangan teknologi yang ada. Dengan begitu kesenjangan yang sering terjadi antara dunia perkuliahan dengan industri dapat diatasi. Dengan sistem belajar yang unik, kreatif, dan inovatif, Jurusan Software Engineering memiliki metode pembelajaran berbasis proyek, yang memberikan kesempatan kepada kamu untuk siap bekerja di negara-negara maju, khususnya Jepang.',
    img: '/assets/img/kit-landing/majors/belajar-software-engineering-di-kit-cambodia-quipper-campus.jpg',
    imgAlt: 'Belajar Software Engineering di KIT Cambodia | Quipper Campus',
  },
  {
    id: '2',
    title: 'Faculty of International Leaders Hospitality Management',
    desc: 'Tidak hanya di Kamboja, kamu juga mendapatkan kesempatan pengalaman kerja di negara-negara ASEAN dan kemudian Jepang serta negara lain di seluruh dunia dengan belajar di Jurusan International Leaders Hospitality Management. Selain itu, Quipperian juga akan memperoleh kegiatan lapangan berskala internasional, yang akan mengajarkan kamu cara memulai bisnis yang baik di sektor ini.',
    img: '/assets/img/kit-landing/majors/belajar-international-leaders-hospitality-management-di-kit-cambodia-quipper-campus.jpg',
    imgAlt: 'Belajar International Leaders Hospitality Management di KIT Cambodia | Quipper Campus',
  },
]

const majorItems = majorsData.map((major, idx) => (
  <MajorItem {...major} key={`mjr-itm-${major.id}-${idx}`}/>
))

const Majors = () => (
  <div id="kit-majors" className="kit-majors">
    <Container>
      <Typography component="h2" variant="title" className="kit-majors__title text-center">
        Jurusan
      </Typography>
      {
        isDOMAvailable && window.outerWidth >= 768 ?
          <Row className="d-flex a-i-stretch">
            {
              majorItems.map((majorItm, idx) => (
                <Col md="6" key={`m-itm-${idx}-${majorItm.id}`}>
                  {majorItm}
                </Col>
              ))
            }
          </Row> :
          <TmvnCarousel id="major-crsl" items={majorItems}/>
      }
    </Container>
  </div>
)

export default Majors
